module.exports = __webpack_public_path__ + "static/media/ciel-logo.cd4d32e4.png";